module.exports = __webpack_public_path__ + "img/gapg-sermons.d83e69d9.png";